import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Box } from "@mui/joy";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { AuthLayout } from "../components/auth/AuthLayout";
import { useAuthStore } from "../store/authStore";

export const WaitlistPage: React.FC = () => {
  const navigate = useNavigate();
  const { profile, session, initialized, isWaitlisted, signOut } =
    useAuthStore();

  // Redirect if not authenticated
  useEffect(() => {
    if (initialized && !session) {
      navigate("/");
    }
  }, [initialized, session, navigate]);

  // Redirect approved users away from waitlist page
  useEffect(() => {
    if (initialized && session && !isWaitlisted()) {
      navigate("/");
    }
  }, [initialized, session, isWaitlisted, navigate]);

  const handleSignOut = async () => {
    await signOut();
    navigate("/");
  };

  const firstName = profile?.full_name?.split(" ")[0];

  return (
    <AuthLayout
      title={firstName ? `Welcome, ${firstName}!` : "You're on the list!"}
      subtitle="We're gradually rolling out access to new users"
    >
      <Box
        data-testid="waitlist-page"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <HourglassEmptyIcon sx={{ fontSize: 48, color: "#6B6B6B", mb: 1 }} />
        <Typography level="body-md" sx={{ color: "#6B6B6B", textAlign: "center" }}>
          You&apos;re on the waitlist. We&apos;ll let you know when your account
          is ready. Check back soon!
        </Typography>
        <Button
          variant="plain"
          color="neutral"
          onClick={handleSignOut}
          sx={{ mt: 2 }}
        >
          Sign out
        </Button>
      </Box>
    </AuthLayout>
  );
};
